import useSWR, { Fetcher } from 'swr';
import { SearchResponse, SearchHit } from '../models/Article';

const fetcher: Fetcher<SearchResponse, string> = (url: string) =>
    fetch(url).then(res => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
    });

export function useSearchData(query: string) {
    const q = query.trim();
    const baseUrl = process.env.REACT_APP_API_URL || "https://7go05sqm8e.execute-api.eu-west-3.amazonaws.com/dev";
    const url = q ? `${baseUrl}/text-search?q=${encodeURIComponent(q)}&size=20` : null;

    const { data, error, isLoading } = useSWR<SearchResponse>(url, fetcher);

    return {
        data: (data?.hits?.hits ?? []) as SearchHit[],
        error: error?.message || "",
        isLoading: isLoading && !!q,
    };
}